import { css } from 'styled-components'

export const flex = (alignItems: string, justifyContent: string) => css`
    align-items: ${alignItems};
    display: flex;
    justify-content: ${justifyContent};
`
